<template>
  <div>
    <el-row style="margin-top: 20px;">
      <el-col :xl="8" :lg="8" :md="8" :sm="8" :xs="8" style="text-align: right;">平台简称：</el-col>
      <el-col :xl="15" :lg="15" :md="15" :sm="15" :xs="15">
        <el-input
            v-model="platformAbbreviationData.val1"
            placeholder="请输入平台简称"
            size="mini"
            style="width: 70%">
        </el-input>
      </el-col>
    </el-row>
    <el-row style="margin-top: 20px;">
      <el-col :xl="8" :lg="8" :md="8" :sm="8" :xs="8" style="text-align: right;">平台全称：</el-col>
      <el-col :xl="15" :lg="15" :md="15" :sm="15" :xs="15">
        <el-input
            v-model="platformFullNameData.val1"
            placeholder="请输入平台全称"
            size="mini"
            style="width: 70%">
        </el-input>
      </el-col>
    </el-row>
    <el-row style="margin-top: 20px;">
      <el-col :xl="8" :lg="8" :md="8" :sm="8" :xs="8" style="text-align: right;">PC端logo：</el-col>
      <el-col :xl="15" :lg="15" :md="15" :sm="15" :xs="15" v-if="PCTerminalLogoData.icon1==undefined || PCTerminalLogoData.icon1==''">
        <el-upload
            v-model="PCTerminalLogoData.icon1"
            :action="uploadPCTerminalLogoUrl"
            :before-upload="beforeUpload"
            class="upload-demo"
            drag
            :accept="'image/*'"
            :on-success="imageChangePCTerminalLogoSuccess"
            :on-error="imageChangeError"
            :show-file-list="false"
            :headers="token"
            style="margin-bottom: 60px;"
            :auto-upload="true">
          <i class="el-icon-plus" style="line-height:80px;height: 80px;width: 80px;"></i>
        </el-upload>
      </el-col>
      <el-col :xl="15" :lg="15" :md="15" :sm="15" :xs="15" v-if="PCTerminalLogoData.icon1!=undefined && PCTerminalLogoData.icon1!=''">
        <div class="upload-div">
          <img class="upload-img" :src="$ftpUrl + PCTerminalLogoData.icon1">
          <div class="delete-icon">
            <span @touchstart="imageRemove('PC_terminal_logo')" @click="imageRemove('PC_terminal_logo')">
              <i class="el-icon-delete"></i>
            </span>
          </div>
        </div>
      </el-col>
    </el-row>
    <el-row >
      <el-col :xl="8" :lg="8" :md="8" :sm="8" :xs="8" style="text-align: right;">移动端logo：</el-col>
      <el-col :xl="15" :lg="15" :md="15" :sm="15" :xs="15" v-if="mobileTerminalLogoData.icon1==undefined || mobileTerminalLogoData.icon1==''">
        <el-upload
            v-model="mobileTerminalLogoData.icon1"
            :action="uploadMobileTerminalLogoUrl"
            class="upload-demo"
            drag
            :accept="'image/*'"
            :before-upload="beforeUpload"
            :on-success="imageChangeMobileTerminalLogoSuccess"
            :on-error="imageChangeError"
            :show-file-list="false"
            :headers="token"
            style="margin-bottom: 60px;"
            :auto-upload="true">
          <i class="el-icon-plus" style="line-height:80px;height: 80px;width: 80px;"></i>
        </el-upload>
      </el-col>
      <el-col :xl="15" :lg="15" :md="15" :sm="15" :xs="15" v-if="mobileTerminalLogoData.icon1!=undefined && mobileTerminalLogoData.icon1!=''">
        <div class="upload-div">
          <img class="upload-img"
               :src="$ftpUrl + mobileTerminalLogoData.icon1">
          <div class="delete-icon">
             <span @touchstart="imageRemove('mobile_terminal_logo')" @click="imageRemove('mobile_terminal_logo')">
               <i class="el-icon-delete"></i>
             </span>
          </div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import {serviceUrl} from "@/utils/request";
import {imgUploadAstrict} from "@/constant/img-upload-astrict";

export default {
  name: "editSystemVision",
  props: {
    platformAbbreviationData: {},
    platformFullNameData: {},
    PCTerminalLogoData: {},
    mobileTerminalLogoData: {},
  },
  data(){
    return{
      uploadPCTerminalLogoUrl: window.g.gatewayUrl.slice(0,-1) + serviceUrl.deviceService + '/api/upload',
      uploadMobileTerminalLogoUrl: window.g.gatewayUrl.slice(0,-1) + serviceUrl.deviceService + '/api/upload',
      token: {},
    }
  },
  created() {
    this.token = {Authorization: 'Bearer' + this.$cookies.get('token')};
  },
  methods:{
    // 文件类型校验
    beforeUpload(file) {
      return imgUploadAstrict(file, this);
    },
    imageChangePCTerminalLogoSuccess(file){
      this.PCTerminalLogoData.icon1 = file.data.domain + file.data.url;
      // 重新渲染
      this.$forceUpdate();
    },
    imageChangeMobileTerminalLogoSuccess(file){
      this.mobileTerminalLogoData.icon1 = file.data.domain + file.data.url;
      // 重新渲染
      this.$forceUpdate();
    },
    imageChangeError(){
      this.$message.error("文件上传失败!")
    },
    imageRemove(row){
      if (row == 'PC_terminal_logo'){
        this.PCTerminalLogoData.icon1='';
      }else if(row == 'mobile_terminal_logo'){
        this.mobileTerminalLogoData.icon1='';
      }
      // 重新渲染
      this.$forceUpdate();
    },
  }
}
</script>

<style scoped>
.delete-icon {
  line-height:80px;height: 80px;width: 80px;position:absolute;text-align: center;display:none;
}
.upload-img {
  position:absolute;width: 80px;height: 80px;
}
.upload-div {
  margin-bottom: 145px;
}
.upload-img:hover+.delete-icon{display:block;}
.delete-icon:hover{display:block;}
</style>
